import DataStore from './DataStore';
import { DEFAULT_USER_PERMISSIONS } from './shared/constants/UserConstants';

import { User, UserPermissions } from '../types/shared/User';

let dataStore = DataStore.getInstance('app');

let UserActions = {
  addUser(newUser: User) {
    let users = dataStore.get('users') || new Map<string, User>();
    // TODO: We probably shouldn't mutate here.
    let newUsers = users.set(newUser.id, newUser);
    dataStore.set('users', newUsers);
    return newUsers;
  },

  updateUserById(id: string, updates: Partial<User>) {
    let users = dataStore.get('users');
    if (users) {
      let oldUser = users.get(id);
      if (oldUser) {
        let userUpdates = {
          ...oldUser,
          ...updates,
        };
        let newUsers = users.set(id, userUpdates);
        dataStore.set('users', newUsers);
        return newUsers;
      }
    }
  },

  updateUser(updates: Partial<User>) {
    let oldUser = dataStore.get('user');
    if (!oldUser) {
      return;
    }
    let newUser = {
      ...oldUser,
      ...updates,
    };
    dataStore.set('user', newUser);
    return newUser;
  },

  updateUserAccess(updates: Partial<UserPermissions>) {
    let oldUser = dataStore.get('user');
    if (!oldUser) {
      return;
    }
    let oldPermissions: UserPermissions =
      oldUser.permissions || DEFAULT_USER_PERMISSIONS;
    let newPermissions = {
      ...oldPermissions,
      ...updates,
    };
    return UserActions.updateUser({
      permissions: newPermissions,
    });
  },

  deleteUserById(id: string) {
    let users = dataStore.get('users');
    if (users) {
      users.delete(id);
      let newUsers = new Map(users);
      dataStore.set('users', newUsers);
    }
  },
};

export default UserActions;
